/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewsArticlesDetail } from '../models/NewsArticlesDetail';
import type { PaginatedNewsArticlesListList } from '../models/PaginatedNewsArticlesListList';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NewsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedNewsArticlesListList
     * @throws ApiError
     */
    public newsArticlesList({
        limit,
        offset,
        ordering,
        search,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedNewsArticlesListList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/news/articles/',
            query: {
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
            },
        });
    }

    /**
     * @returns NewsArticlesDetail
     * @throws ApiError
     */
    public newsArticlesRetrieve({
        id,
    }: {
        id: number,
    }): CancelablePromise<NewsArticlesDetail> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/news/articles/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
